import { cn } from '../../utils/cn'
import { Button } from './button'

/** Round ghost button shared by the matched-broker call, email and note actions so they match. */
export function BrokerActionButton({ className, children, ...props }: React.ComponentProps<typeof Button>) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      className={cn('text-ink-600 rounded-full', className)}
      {...props}
    >
      {children}
    </Button>
  )
}
